import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Dashboard() {
  const navigate = useNavigate();
  const [accountStatus] = useState<'pending' | 'approved' | 'rejected'>('approved');

  const quickActions = [
    {
      icon: 'ri-briefcase-line',
      title: 'الوظائف المتاحة',
      subtitle: '12 وظيفة جديدة',
      color: 'bg-[#1565C0]',
      path: '/jobs'
    },
    {
      icon: 'ri-folder-line',
      title: 'مشاريعي',
      subtitle: '3 مشاريع نشطة',
      color: 'bg-[#607D8B]',
      path: '/projects'
    },
    {
      icon: 'ri-time-line',
      title: 'الحضور والانصراف',
      subtitle: 'تسجيل اليوم',
      color: 'bg-[#FBC02D]',
      path: '/attendance'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'المستحقات',
      subtitle: '2,500 ريال',
      color: 'bg-[#4CAF50]',
      path: '/payments'
    }
  ];

  const recentActivities = [
    {
      icon: 'ri-check-line',
      title: 'تم قبولك في مشروع معرض الرياض',
      time: 'منذ ساعتين',
      type: 'success'
    },
    {
      icon: 'ri-time-line',
      title: 'تم تسجيل حضورك اليوم',
      time: 'منذ 4 ساعات',
      type: 'info'
    },
    {
      icon: 'ri-star-line',
      title: 'حصلت على تقييم 5 نجوم',
      time: 'أمس',
      type: 'success'
    }
  ];

  const getStatusCard = () => {
    switch (accountStatus) {
      case 'pending':
        return (
          <Card className="mb-6 border-r-4 border-[#FBC02D]">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-[#FBC02D]/10 rounded-full flex items-center justify-center ml-4">
                <i className="ri-time-line text-[#FBC02D] text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-[#333333]">قيد المراجعة</h3>
                <p className="text-[#757575] text-sm">تم إرسال طلبك للمراجعة من قسم الموارد البشرية</p>
              </div>
            </div>
          </Card>
        );
      case 'approved':
        return (
          <Card className="mb-6 border-r-4 border-[#4CAF50]">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-[#4CAF50]/10 rounded-full flex items-center justify-center ml-4">
                <i className="ri-check-line text-[#4CAF50] text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-[#333333]">تم اعتماد الحساب</h3>
                <p className="text-[#757575] text-sm">يمكنك الآن التقديم على الوظائف المتاحة</p>
              </div>
            </div>
          </Card>
        );
      case 'rejected':
        return (
          <Card className="mb-6 border-r-4 border-red-500">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center ml-4">
                <i className="ri-close-line text-red-500 text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-[#333333]">تم رفض الطلب</h3>
                <p className="text-[#757575] text-sm">يرجى مراجعة المستندات وإعادة التقديم</p>
              </div>
            </div>
          </Card>
        );
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="FutureStaff"
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-notification-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-20 px-4">
        {/* Welcome Section */}
        <div className="mb-6 mt-4">
          <h2 className="text-2xl font-bold text-[#333333] mb-2">
            مرحباً، أحمد محمد
          </h2>
          <p className="text-[#757575]">
            اليوم هو يوم رائع لبدء مشروع جديد
          </p>
        </div>

        {/* Account Status */}
        {getStatusCard()}

        {/* Quick Actions */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">الإجراءات السريعة</h3>
          <div className="grid grid-cols-2 gap-4">
            {quickActions.map((action, index) => (
              <Card 
                key={index} 
                className="p-4 hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => navigate(action.path)}
              >
                <div className="text-center" onClick={() => navigate(action.path)}>
                  <div 
                    className={`w-12 h-12 ${action.color} rounded-full flex items-center justify-center mx-auto mb-3 cursor-pointer`}
                    onClick={() => navigate(action.path)}
                  >
                    <i className={`${action.icon} text-white text-xl`}></i>
                  </div>
                  <h4 
                    className="font-semibold text-[#333333] text-sm mb-1 cursor-pointer"
                    onClick={() => navigate(action.path)}
                  >
                    {action.title}
                  </h4>
                  <p className="text-[#757575] text-xs">{action.subtitle}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Recent Activities */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">النشاطات الأخيرة</h3>
          <Card>
            <div className="space-y-4">
              {recentActivities.map((activity, index) => (
                <div key={index} className="flex items-start">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ml-3 ${
                    activity.type === 'success' ? 'bg-[#4CAF50]/10' : 'bg-[#1565C0]/10'
                  }`}>
                    <i className={`${activity.icon} text-sm ${
                      activity.type === 'success' ? 'text-[#4CAF50]' : 'text-[#1565C0]'
                    }`}></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-[#333333] text-sm font-medium">{activity.title}</p>
                    <p className="text-[#757575] text-xs">{activity.time}</p>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* CTA Section */}
        <Card className="text-center bg-gradient-to-r from-[#1565C0] to-[#1976D2] text-white">
          <div className="py-4">
            <h3 className="text-lg font-semibold mb-2">ابدأ رحلتك المهنية</h3>
            <p className="text-white/90 text-sm mb-4">
              اكتشف الوظائف المتاحة وابدأ في كسب المال
            </p>
            <Button variant="accent" size="sm" onClick={() => navigate('/jobs')}>
              استعراض الوظائف
            </Button>
          </div>
        </Card>
      </div>

      <BottomNavigation />
    </div>
  );
}
